import type { ReactNode, RefObject } from "react";
import { createPortal } from "react-dom";
import { NoSSR } from "./no-ssr";

type Props = {
  target?: null | HTMLElement | RefObject<HTMLElement | null>;

  children: ReactNode | ReactNode[];
};

/**
 * portals needs to interact with the dom to actually mount in the target where
 * they are needed. This isn't possible during SSR.
 *
 * As such this component aims to create portals that does not trigger
 * hydration issues as they will only ever render on the clientside AFTER the
 * initial mount has been completed.
 */
export function IsomorphicPortal(props: Props): React.JSX.Element | null {
  if (typeof document === "undefined") {
    return null;
  }

  return (
    <NoSSR>
      {createPortal(
        props.children,
        (props.target && "current" in props.target
          ? props.target.current
          : props.target) || document.body,
      )}
    </NoSSR>
  );
}
